import { fetchProductsDatasource } from "../api/products";

export async function getProductsDatasource(tag: string) {
  const response = await fetchProductsDatasource(tag);
  return response.products.sort((a, b) => a.title.localeCompare(b.title));
}
